export default [
  {
    id: 'tutor1',
    urls: [
      require('assets/tutorial/tutor1.txt'),
      require('assets/tutorial/tutor1.png'),
      require('assets/tutorial/tutor1.atlas'),
    ],
  },
  {
    id: 'tutor2',
    urls: [
      require('assets/tutorial/tutor2.txt'),
      require('assets/tutorial/tutor2.png'),
      require('assets/tutorial/tutor2.atlas'),
    ],
  },
  {
    id: 'tutor3',
    urls: [
      require('assets/tutorial/tutor3.txt'),
      require('assets/tutorial/tutor3.png'),
      require('assets/tutorial/tutor3.atlas'),
    ],
  },
  {
    id: 'tutor4',
    urls: [
      require('assets/tutorial/tutor4.txt'),
      require('assets/tutorial/tutor4.png'),
      require('assets/tutorial/tutor4.atlas'),
    ],
  },
  {
    id: 'ui',
    urls: [
      require('assets/ui/logoswap.png'),
      require('assets/ui/welcomeSprite3.png'),
      require('assets/ui/logo/logo-kids.png'),
      require('assets/ui/logo/logo-adults.png'),
      require('assets/ui/qroffical.jpg'),
      require('assets/ui/spark.png'),
      require('assets/ui/pattern2.png'),
      require('assets/ui/liqtrans.png'),
    ],
  },

]
